import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAnmlTRpIEj2gE_TwSsibJ0ZDwviTAq_ds",
  authDomain: "betabuyers.firebaseapp.com",
  projectId: "betabuyers",
  storageBucket: "betabuyers.firebasestorage.app",
  messagingSenderId: "1047848821210",
  appId: "1:1047848821210:web:bda2d0382d58a8a54c20e3"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;